import { getClientSideURL } from "@/utilities/getURL";

/**
 * Processes media resource URL to ensure proper formatting
 * @param url The original URL from the resource
 * @param cacheTag Optional cache tag to append to the URL
 * @returns Properly formatted URL with cache tag if provided
 */
export const getMediaUrl = (
  url: string | null | undefined,
  cacheTag?: string | null,
): string => {
  if (!url) return "";

  if (cacheTag && cacheTag !== "") {
    cacheTag = encodeURIComponent(cacheTag);
  }

  // Check if URL already has http/https protocol
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return cacheTag ? `${url}?${cacheTag}` : url;
  }

  // Otherwise prepend client-side URL
  const baseUrl = getClientSideURL();
  return cacheTag ? `${baseUrl}${url}?${cacheTag}` : `${baseUrl}${url}`;
};

type MediaLike = {
  url?: string | null;
  filename?: string | null;
};

/**
 * Resolves a Payload media object to a browser-ready URL (min-skola ContentBlock pattern).
 * Use with native `<img>` / CSS backgrounds, or with `next/image` when the URL is a
 * Vercel Blob host already allowed in `next.config` remotePatterns.
 */
export const resolveMediaSrc = (
  media?: MediaLike | string | null,
): string => {
  if (!media || typeof media === "string") return "";
  if (media.url) return getMediaUrl(media.url);
  if (media.filename) return getMediaUrl(`/media/${media.filename}`);
  return "";
};
